import { Component, OnInit } from '@angular/core';
import { DataService } from '../data.service';
import { GeneralService } from '../general.service';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-enetassess',
  templateUrl: './enetassess.component.html',
  styleUrls: ['./enetassess.component.scss']
})
export class EnetassessComponent implements OnInit {

  public logo = "";
  public exisitingLangauge = "en";
  public languageSelected = "en";
  public exams = [];
  public currentExam = 0;
  public isLoaded = false;

  private _loadInterval = null;
  private _initInterval = null;

  constructor(
    public dataSvc: DataService,
    public generalSvc: GeneralService,
    public translate: TranslateService
  ) {
    const isMock = this.dataSvc.checkMockDetails();
    var examCompleteMsg = localStorage.getItem("exam-complete-msg");
    if (examCompleteMsg != null && examCompleteMsg != undefined) {
      localStorage.removeItem("exam-complete-msg");
    }
    /*if (this.dataSvc.getParameterByName("eproctored") == "1") {
      this.dataSvc.showLoading("Reloading exam data...");
      setTimeout(() => {
        this.dataSvc.attemptLoginLocally();
        this.loadData(isMock);
      }, 1000);
    } else {
      this.loadData(isMock);
    }*/
    
    this.dataSvc.showLoading("Reloading exam data...");   
    this._loadInterval = setInterval( () => {
      if(!this.dataSvc.syncingConfig){
        this.dataSvc.attemptLoginLocally();
        this.loadData(isMock)
        clearInterval(this._loadInterval);
      }
    }, 2000);
  }

  loadData(isMock: any) {
    console.log(this.dataSvc.currentUser.Exams);
    if (this.dataSvc.currentUser.ScheduleCandidate == null || this.dataSvc.currentUser.Exams.length == 0) {
      if (isMock !== null && isMock !== undefined) {
        this.generalSvc.logoutMockUser(isMock.MockId);
      }
      else {
        this.generalSvc.logoutUserDelayed();
      }
    }

    if (this.dataSvc.currentUser.Exams.filter(x => x.Completed != true).length == 0) {
      if (isMock !== null && isMock !== undefined) {
        this.generalSvc.logoutMockUser(isMock.MockId);
      }
      else {
        this.generalSvc.logoutUserDelayed();
      }
    }

    this.exisitingLangauge = localStorage.getItem("userslanguage");
    if (this.exisitingLangauge !== null && this.exisitingLangauge !== undefined && this.exisitingLangauge !== "") {
      this.dataSvc.changeLangauge(this.exisitingLangauge);
      this.languageSelected = this.exisitingLangauge;
    }
    else {
      this.translate.setDefaultLang("en");
      this.translate.use("en");
      this.exisitingLangauge = "en";
    }

    this.isLoaded = true;
  }

  ngOnInit() {
    this._initInterval = setInterval( () => {
      if(!this.dataSvc.syncingConfig){
        this.onInit();
        clearInterval(this._initInterval);
      }
    }, 2000);
  }

  onInit() {
    var selLangauge = (<HTMLSelectElement>document.getElementById("selLangauge"));
    if (selLangauge !== null && selLangauge !== undefined) {
      selLangauge.value = this.exisitingLangauge.toString();
    }
    this.exams = this.dataSvc.currentUser.Exams; //.filter(x => (x.Completed == null || x.Completed == undefined || !x.Completed) && x.Status < 5);
    for (var exam of this.dataSvc.currentUser.Exams) {
      if (exam.Completed == null || exam.Completed == undefined || !exam.Completed && exam.Status < 5) {
        let index = this.exams.findIndex(x => x === exam && !x.Session.IsCandidateOralPrep);
        if (index >= 0) {
          this.currentExam = index;
          return;
        }
      }
    }
    this.isLoaded = true;
  }

  changeLangauge(language) {
    localStorage.setItem("userslanguage", language.toString());
    this.translate.setDefaultLang(language.toString());
    this.translate.use(language.toString());
    this.languageSelected = language.toString();
  }


  launchExam(examIndex) {
    this.dataSvc.currentExamIndex = examIndex;
    localStorage.setItem("syncItemExamIndex", examIndex);
    this.dataSvc.pulseTimeLog("Start");
    this.generalSvc.launchExam();
  }

  logout() {
    this.generalSvc.logoutUser();
  }
}